<form [formGroup]="nuevoVinculoFormGroup">
  <mat-stepper linear="true" #stepper>
    <mat-step>
      <ng-template matStepLabel>Empresa a vincularse</ng-template>
      <h4>Empresa a vincularse</h4>
      <p>Ingresa los datos de la empresa a vincularse.</p>
      <mat-radio-group aria-label="" formControlName="tipo_persona" required (change)="handleChangeTipoPersona($event)">
        <label id="example-radio-group-label" required>Tipo de empresa:</label>
        <mat-radio-button value="persona_juridica" [checked]="true"> Persona jurídica </mat-radio-button>
        <mat-radio-button value="persona_fisica"> Persona física </mat-radio-button>
      </mat-radio-group>

      <!--  se oculta porque si se usa ngif el viewchild no lo encuentra-->
      <div [hidden]="nuevoVinculoFormGroup.get('tipo_persona').value !=='persona_fisica'">
        <h4>Documento</h4>
        <div class="row">
          <div class="col-sm-12" #documentoPersonaRPE>
            <rpe-documento-persona-form [formInput]="documentoPersonaFormInput">
            </rpe-documento-persona-form>
          </div>
        </div>
      </div>
      <div [hidden]="nuevoVinculoFormGroup.get('tipo_persona').value!=='persona_juridica'">
        <h4>RUT</h4>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field class="col-sm-12">
              <input matInput placeholder="RUT" formControlName="rut" type="text" required>
              <mat-error *ngIf="nuevoVinculoFormGroup.get('rut')?.hasError('required')">
                Debe ingresar rut de la empresa
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-error *ngIf="!existeEmpresa">
            La empresa indicada no fue registrada ante INASE
          </mat-error>
        </div>
      </div>
      <div>
        <button mat-button mat-raised-button color="primary" type="button"
          (click)="onSiguienteStepEmpresa()">Siguiente</button>
      </div>
    </mat-step>
    <mat-step label="Rol">
      <h4>Rol</h4>
      <mat-form-field class="col-xs-12 col-sm-6">
        <mat-label>Tipo de rol</mat-label>
        <mat-select formControlName="tipo_rol" required>
          <mat-option *ngFor="let rol of formInput.tipos_rol" [value]="rol.id">
            {{rol.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="nuevoVinculoFormGroup.get('tipo_rol')?.hasError('required')">
          Debe ingresar un rol
        </mat-error>
      </mat-form-field>

      <!-- el tipo rol es igual a tecnico responsable-->
      <div *ngIf="actividadesCheck.length>0 && nuevoVinculoFormGroup.get('tipo_rol').value == 5">
        <hr>
        <h4>Seleccionar actividades</h4>
        <span>Seleccione las actividades que quiere ser Técnico Responsable.</span>

        <div *ngFor="let choice of actividadesCheck; let indice=index" class="col-md-12">
          <label>
            <input type="checkbox" [value]="choice.value" (change)="onCheckChange($event,indice)" checked>
            {{choice.actividadConNombre.nombreActividad}}
          </label>
        </div>
        <mat-error *ngIf="sinActividades">
          Debe seleccionar al menos una actividad
        </mat-error>
      </div>
      <div class="actions">
        <button mat-raised-button type="button" matStepperPrevious>Volver</button>
        <button mat-raised-button color="primary" (click)="onSubmit()" type="submit">Confirmar</button>
      </div>
    </mat-step>
  </mat-stepper>
</form>
